import { useSelector, useDispatch } from 'react-redux';
import { FaCog } from 'react-icons/fa';
import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify'; // Assuming react-toastify is used for toasts
import 'react-toastify/dist/ReactToastify.css'; // Import toast styles
import { cancelSub } from '../features/subscription/subscriptionSlice';
import { useSubStatus } from '../hooks/useSubStatus';
import PricingTable from './stripe/PricingTable';
import CancelSubscriptionModal from './userInfoComponents/CancelSubscriptionModal'; // Import the modal component

const SubscriptionDetails = () => {
    const dispatch = useDispatch();
    const [dropdownVisible, setDropdownVisible] = useState(false);
    const [showCancelModal, setShowCancelModal] = useState(false);

    const { subInfo, message } = useSelector(state => state.subscription);
    const { hasSubscription, subStatus, subTier } = useSubStatus();

    useEffect(() => {
        if (message) {
            toast(message); // Display the toast with the message
            dispatch({ type: 'subscription/clearMessage' }); // Dispatch an action to clear the message
        }
    }, [message, dispatch]);

    const handleCancelSubscription = () => {
        setShowCancelModal(true);
    };

    const confirmCancelSubscription = () => {
        dispatch(cancelSub());
        setShowCancelModal(false);
    };

    const closeModal = () => {
        setShowCancelModal(false);
    };

    const handleModifySubscription = () => {
        console.log("Modify subscription clicked");
    };

    const toggleDropdown = () => {
        setDropdownVisible(!dropdownVisible);
    };

    if (!hasSubscription) {
        return (
            <>  
                <div className='text-left mb-6'>
                    <h1 className='text-2xl font-sans font-semibold text-charcoal'>Unlock Premium Features Today!</h1>
                </div>

                <div className='flex justify-center'>
                    <PricingTable 
                        style={{ position: 'relative', width: '100%', maxWidth: '800px' }}/>
                </div>
                                

            </>
        );
    } else {
        return (
            <>
                <div className='text-left mb-4'>
                    <h1 className='text-2xl font-sans font-normal text-charcoal'>Subscription Information</h1>
                </div>
               
                <div className="w-full bg-ivory p-6 rounded-lg shadow-md">
                    <p className="text-md mb-2 text-gray-700"><span className="font-semibold">Subscription Name:</span> {subTier} </p>  
                    <p className="text-md mb-2 text-gray-700"><span className="font-semibold">Status:</span> {subStatus} </p>
                    
                    <p className="text-md mb-2 text-gray-700"><span className="font-semibold">Cycle Start:</span> {new Date(subInfo.subPeriodStart * 1000).toLocaleDateString()}</p>
                    <p className="text-md mb-2 text-gray-700"><span className="font-semibold">Cycle End:</span> {new Date(subInfo.subPeriodEnd * 1000).toLocaleDateString()}</p>
                    {subInfo.cancel_at_period_end && (
                        <p className="text-md mb-2 font-sans font-bold">
                            Subscription will cancel at period end
                        </p>
                    )}
                    {subStatus === "trialing" && (
                        <p className="text-sm mt-4 text-red-600 font-sans font-semibold">
                            You are currently in trial period. Please add a credit card before the cycle ends to continue having access.
                        </p>
                    )}
                </div>

                <div className="relative flex justify-end mt-6">
                    <button
                        type="button"
                        className="group relative px-4 py-2 bg-charcoal text-white font-semibold rounded-lg hover:bg-teal transition duration-200"
                        onClick={toggleDropdown}
                    >
                        <FaCog className="text-xl" />
                    </button>
                    {dropdownVisible && (
                        <div className="absolute top-full right-0 lg:left-full lg:top-0 mt-2 lg:mt-0 lg:ml-2 w-48 bg-white border border-gray-300 rounded-lg shadow-lg z-10">
                            {/* <button
                                type="button"
                                className="block w-full px-4 py-2 text-left bg-charcoal text-white hover:bg-teal"
                                onClick={handleModifySubscription}
                            >
                                Modify Subscription
                            </button> */}
                            <button
                                type="button"
                                className="block w-full px-4 py-2 text-left text-white bg-red-500"
                                onClick={handleCancelSubscription}
                            >
                                Cancel Subscription
                            </button>
                        </div>
                    )}
                </div>

                {showCancelModal && (
                    <CancelSubscriptionModal
                        onClose={closeModal}
                        onConfirm={confirmCancelSubscription}
                    />
                )}

                <div className='mt-6 text-sm text-gray-600'>
                    <p>Contact us at <a className='underline text-blue-700' href="mailto:support@timestat.app">support@timestat.app</a> for any questions, concerns, or requests.</p>
                </div>
            </>
        );
    }
}

export default SubscriptionDetails;
